import { combineReducers } from 'redux';
import adicionaRole from './componentes/reducers/reducers';
import adicionaEntidade from './componentes/reducers/reducerEntidade';

export default combineReducers({
    dadosRole: adicionaRole,
    dadosEntidade: adicionaEntidade
})
